export const SOURCE_TYPE_MAPPING: Record<string, string> = {
  dropped_file: "Dropped File",
  sample: "Sample",
  memory_dump: "Memory Dump",
  unpacked_pe: "Unpacked PE",
  html: "HTML",
  pcap: "PCAP",
  other: "Other"
};
